const awsmobile = {
    "aws_project_region": process.env.REACT_APP_AWS_REGION,
    "aws_cognito_identity_pool_id": process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    "aws_cognito_region": process.env.REACT_APP_AWS_REGION,
    "aws_user_pools_id": process.env.REACT_APP_COGNITO_USER_POOL_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_appsync_region": process.env.REACT_APP_AWS_REGION,
};

export default awsmobile;

/**
 * REACT_APP_COGNITO_USER_POOL_ID=ap-south-1_RacmmbFoC
REACT_APP_COGNITO_APP_CLIENT_ID=79tcpb3ettsvhsfe4bkasre5lu
REACT_APP_COGNITO_IDENTITY_POOL_ID=ap-south-1:9ae4edcd-5a52-4082-9a6f-f89b401db873
REACT_APP_API_BASE_URL=https://testapi.identxlabs.com
APP_BUILD_S3_BUCKET_NAME=webapp-test-mumbai
AWS_REGION=ap-south-1
REACT_APP_WEB_URL=qaapp.identxlabs.com
CLOUD_FRONT_DISTRIBUTION_ID=E1F8EE1B3QAULV
REACT_APP_ADMIN_USER_EMAIL=sajan@identxlabs.com
 */